module.exports = __webpack_public_path__ + "media/images/locations/chicago-e160f608d1e4a2ec2cfb2a216694b681.jpg";